import { render } from "./AnnouncementsBanner.vue?vue&type=template&id=b025354a&ts=true"
import script from "./AnnouncementsBanner.vue?vue&type=script&lang=ts"
export * from "./AnnouncementsBanner.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__